import React, { useEffect, useState } from 'react';
import { Gauge, PlusCircle } from 'lucide-react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '../ui/alert-dialog.js';

const normalizeMileage = (value) => {
    if (value === '' || value === null || value === undefined)
        return 0;
    const number = Number(value);
    return Number.isFinite(number) && number >= 0 ? number : null;
};

const VehicleVisitStartDialog = ({ open, onOpenChange, onConfirm, isLoading = false, defaultMileage = '' }) => {
    const [mileage, setMileage] = useState('');
    const normalizedMileage = normalizeMileage(mileage);
    const valid = normalizedMileage !== null;

    useEffect(() => {
        if (open && !isLoading)
            setMileage(defaultMileage === null || defaultMileage === undefined ? '' : String(defaultMileage));
    }, [defaultMileage, isLoading, open]);

    return (
        <AlertDialog open={open} onOpenChange={(nextOpen) => !isLoading && onOpenChange?.(nextOpen)}>
            <AlertDialogContent dir="rtl" className="border-0 p-0 bg-transparent" data-testid="vehicle-visit-start-dialog">
                <div
                    className="rounded-[28px] overflow-hidden"
                    style={{
                        background: 'radial-gradient(circle at 12% 18%, rgba(14,165,233,0.24), transparent 52%), radial-gradient(circle at 88% 78%, rgba(16,185,129,0.14), transparent 55%), rgba(15,23,42,0.98)',
                        border: '1px solid rgba(56,189,248,0.34)',
                        boxShadow: '0 40px 140px rgba(2,6,23,0.9)',
                    }}
                >
                    <AlertDialogHeader className="px-6 pt-6 text-right">
                        <div className="flex items-start gap-3">
                            <div className="w-12 h-12 rounded-2xl bg-sky-400/15 border border-sky-300/25 flex items-center justify-center shrink-0">
                                <PlusCircle className="text-sky-100" size={22} />
                            </div>
                            <div>
                                <AlertDialogTitle className="text-slate-50 text-lg font-bold">فتح زيارة جديدة</AlertDialogTitle>
                                <AlertDialogDescription className="text-slate-200/80 text-sm mt-2 leading-6">
                                    أدخل قراءة العداد إن كانت متاحة. ستُفتح زيارة تشغيلية جديدة فقط، ولا ينشأ أي أثر مالي قبل اعتماد إجماليها النهائي.
                                </AlertDialogDescription>
                            </div>
                        </div>
                    </AlertDialogHeader>

                    <div className="px-6 pt-5">
                        <label className="text-sm font-semibold text-slate-100" htmlFor="vehicle-visit-start-mileage">قراءة العداد (كم)</label>
                        <div className="mt-2 flex items-center gap-2 rounded-xl border border-slate-500/50 bg-white/95 px-3">
                            <Gauge className="text-slate-500" size={18} />
                            <input
                                id="vehicle-visit-start-mileage"
                                type="number"
                                min="0"
                                step="1"
                                inputMode="numeric"
                                value={mileage}
                                onChange={(event) => setMileage(event.target.value)}
                                placeholder="اختياري"
                                className="w-full bg-transparent py-3 text-sm text-slate-900 outline-none"
                                data-testid="vehicle-visit-start-mileage"
                            />
                        </div>
                        {!valid && <p className="mt-2 text-xs text-rose-200">أدخل رقمًا موجبًا أو صفرًا.</p>}
                    </div>

                    <AlertDialogFooter className="px-6 pb-6 pt-5 gap-2 sm:gap-3 sm:justify-end">
                        <AlertDialogCancel className="apple-button-secondary" disabled={isLoading} data-testid="vehicle-visit-start-cancel">
                            إلغاء
                        </AlertDialogCancel>
                        <AlertDialogAction
                            className="h-11 px-4 rounded-xl bg-sky-600 hover:bg-sky-500 text-white text-sm font-bold disabled:opacity-50"
                            data-testid="vehicle-visit-start-submit"
                            disabled={isLoading || !valid}
                            onClick={(event) => {
                                event.preventDefault();
                                if (valid)
                                    onConfirm?.({ mileage: normalizedMileage });
                            }}
                        >
                            {isLoading ? 'جارٍ فتح الزيارة...' : 'فتح الزيارة'}
                        </AlertDialogAction>
                    </AlertDialogFooter>
                </div>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default VehicleVisitStartDialog;
